import { render, staticRenderFns } from "./simplifyNotepadManageList.vue?vue&type=template&id=9015ffe2&scoped=true"
import script from "./simplifyNotepadManageList.vue?vue&type=script&lang=js"
export * from "./simplifyNotepadManageList.vue?vue&type=script&lang=js"
import style0 from "./simplifyNotepadManageList.vue?vue&type=style&index=0&id=9015ffe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9015ffe2",
  null
  
)

export default component.exports